import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface DividerProps {
  spacing?: 'sm' | 'md' | 'lg';
}

export function Divider({ spacing = 'md' }: DividerProps) {
  const padding = spacing === 'sm' ? 'py-4' : spacing === 'lg' ? 'py-16' : 'py-8';
  return (
    <Container>
      <div className={padding}>
        <hr className="border-t border-stone-200" />
      </div>
    </Container>
  );
}

export const DividerConfig: ComponentConfig<DividerProps> = {
  fields: {
    spacing: {
      type: 'select',
      options: [
        { label: 'Petit', value: 'sm' },
        { label: 'Moyen', value: 'md' },
        { label: 'Grand', value: 'lg' },
      ],
    },
  },
  defaultProps: { spacing: 'md' },
  render: Divider,
};
